import Link from "next/link";

export const faqData = [
  {
    question: "What types of treatment do you offer?",
    answer: "We offer a comprehensive range of fertility investigations and treatments for both single people and couples. This includes fertility preservation, IUI, IVF, genetic testing, with a personalised treatment plan, tailored to your specific needs and circumstances.",
  },
  {
    question: "How long does treatment take?",
    answer: "The duration of treatment varies depending on the treatment type and individual circumstances. A typical IVF cycle takes about 4 weeks, whilst other treatments may be shorter or longer. During your initial consultation, we'll provide a detailed timeline based on your specific treatment plan.",
  },
  {
    question: "What are your success rates?",
    answer: "Success rates vary based on multiple factors including age, medical history, and treatment type. We maintain high success rates and will discuss your individual chances of success during your consultation.",
  },
  {
    question: "How much does treatment cost?",
    answer: (
      <>
        Treatment costs vary depending on the type of treatment and individual needs. We offer transparent pricing and will provide detailed cost information during your consultation.{" "}
        <Link href="/services/pricing" className="text-brand-blue hover:text-brand-pink underline">
          View our pricing page
        </Link>{" "}
        for more details.
      </>
    ),
  },
  {
    question: "What tests will I need?",
    answer: "Initial fertility testing typically includes hormone blood tests, ultrasound scans, and semen analysis (if applicable). Additional tests may be recommended based on your individual circumstances. We'll explain all necessary tests during your consultation.",
  },
]

